import React from 'react';
import Image from 'next/legacy/image';
import QINIULoader from '../../utils/qiniuLoader';
import { URLNode } from './utils/rich-parser';

interface Props {
  node: URLNode;
  richTextProps: any;
}

export default function Url({ node, richTextProps }: Props) {
  const size = (richTextProps?.style?.fontSize || 16) - 4;

  return (
    <span
      onClick={(e) => {
        e.stopPropagation();
        window.open(node.url, '_blank');
      }}
    >
      <span className='cursor-pointer' style={{ color: '#1C4781' }}>
        <Image
          src='https://i9.taou.com/maimai/p/31048/3019_6_4BQicXXHuMAmwg'
          width={size}
          height={size}
          loader={QINIULoader}
        />
        &nbsp;网页链接
      </span>
    </span>
  );
}
